import { useRef, useEffect, useState } from 'react';
import classNames from 'classnames/bind';

import styles from './index.module.scss';
// import LinkButton from '../../../components/linkButton';

const cx = classNames.bind(styles);

const S07 = () => {
  const [isOverlap, setOverlap] = useState(false);
  const observeRef = useRef();

  useEffect(() => {
    if (observeRef.current) {
      const observer = new IntersectionObserver((entry) => {
        setOverlap(entry[0].isIntersecting);
      });
      observer.observe(observeRef.current);
    }
  }, []);

  return (
    <section className={cx('container')}>
      <div className={cx('wrapper')}>
        <h2 className={cx('title')}>
          Cute. Colorful.
          <br />
          Super Easy.
        </h2>
        <div className={cx(['descWrapper', isOverlap && 'enable'])}>
          <p className={cx('desc')}>
            Skincare should be fun and easy — just like our product.
            <br />
            Glide it on with a smile — quick, simple, and playful!
            <br />
            Perfectly sized for little hands, and loved by parents.
            <br />
            Add a pop of color to your routine, anytime, anywhere!
          </p>
          {/* <LinkButton title="SHOP NOW" link="https://smartstore.naver.com/levrai_cosmetic" color="purple" /> */}
        </div>
      </div>
      <div className={cx(['cover', isOverlap && 'enable'])} />
      <div ref={observeRef} className={cx('observe')} />
    </section>
  );
};

export default S07;
